import axios from 'axios';
import qs from 'qs';

export const getStudentUnsubscribeReasons = (params: Record<string, any>) =>
  axios.get(`/api/v1/student-unsubscribe-reasons?${qs.stringify(params)}`);

export const getStudentUnsubscribeReasonsByStudentId = ({
  studentId,
  params,
}: {
  studentId: string;
  params: Record<string, any>;
}) =>
  axios.get(
    `/api/v1/student-unsubscribe-reasons/students/${studentId}?${qs.stringify(
      params,
    )}`,
  );
